// GENERATED by scripts/build-icons.mjs from icons/flask-conical.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const FlaskConical = createIcon('flask-conical', [
  ['path', { d: "M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2" }],
  ['path', { d: "M6.453 15h11.094" }],
  ['path', { d: "M8.5 2h7" }],
])
